import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "modal is-active" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "modal-background" }, null, -1);
const _hoisted_3 = { class: "modal-card" };
const _hoisted_4 = { class: "modal-card-head" };
const _hoisted_5 = { class: "modal-card-title" };
const _hoisted_6 = { class: "modal-card-body" };
const _hoisted_7 = { class: "field" };
const _hoisted_8 = { class: "control has-icons-left" };
const _hoisted_9 = { class: "icon is-small is-left" };
const _hoisted_10 = { class: "field" };
const _hoisted_11 = { class: "control has-icons-left" };
const _hoisted_12 = { class: "icon is-small is-left" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("p", null, "Mail und Buchungscode gefunden!", -1);
const _hoisted_14 = { class: "modal-card-foot is-flex is-justify-content-space-around" };
import { API } from "@/lib/api";
import { APIError } from "@/lib/api_error";
import { createDebounce, loading_success } from "@/lib/helpers";
import { PublicStore } from "@/lib/store/public";
import { toast } from "bulma-toast";
import { computed, nextTick, onMounted, ref } from "vue";
import BulmaButton from "@/bulma/Button.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ClaimModal',
    props: {
        pitch: {}
    },
    emits: ["close"],
    setup(__props, { emit: __emit }) {
        const store = PublicStore();
        const emit = __emit;
        const props = __props;
        const mail = ref("");
        const booking_code = ref("");
        const ticket_count = ref(null);
        const mail_input = ref(null);
        onMounted(() => {
            nextTick(() => {
                if (!(mail_input.value instanceof HTMLElement))
                    return;
                mail_input.value.focus();
            });
        });
        const guest_auth_data = computed(() => {
            if (!loading_success(store.selected_event))
                return null;
            return {
                event_id: store.selected_event.id,
                mail: mail.value,
                booking_code: booking_code.value,
            };
        });
        const guest_input_debounce = createDebounce();
        function guest_input() {
            guest_input_debounce(() => {
                API.request({
                    method: "POST",
                    endpoint: "pitch/available_tickets",
                    data: guest_auth_data.value,
                })
                    .then((count) => (ticket_count.value = count))
                    .catch(() => (ticket_count.value = null));
            });
        }
        async function submit() {
            if (guest_auth_data.value === null)
                return;
            try {
                await API.request({
                    method: "POST",
                    endpoint: `pitch/${props.pitch.id}/claim`,
                    data: guest_auth_data.value,
                });
                toast({
                    message: "Platz erfolgreich gebucht! Du erhältst eine Bestätigung an deine Mail-Adresse.",
                    type: "is-success",
                });
                store.reload_event();
                emit("close");
            }
            catch (error) {
                if (error instanceof APIError) {
                    if (error.axios_error?.response === undefined) {
                        error.alert();
                        return;
                    }
                    let reason = "Das hat leider nicht geklappt :(";
                    let close = false;
                    switch (error.axios_error?.response.status) {
                        case 404:
                            reason = "Mail, Buchungscode und/oder Platz nicht gefunden.";
                            break;
                        case 403:
                            reason = "Du hast keine Reservierungen übrig.";
                            close = true;
                            break;
                        case 409:
                            reason = "Der Platz ist leider schon vergeben.";
                            close = true;
                            break;
                    }
                    toast({ message: reason, type: "is-warning" });
                    if (close) {
                        store.reload_event();
                        emit("close");
                    }
                }
                else {
                    console.error(error);
                }
            }
        }
        return (_ctx, _cache) => {
            const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("header", _hoisted_4, [
                        _createElementVNode("p", _hoisted_5, "Platz " + _toDisplayString(_ctx.pitch.name) + " buchen", 1),
                        _createElementVNode("button", {
                            class: "delete",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.$emit('close')), ["left"]))
                        })
                    ]),
                    _createElementVNode("article", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("p", _hoisted_8, [
                                _withDirectives(_createElementVNode("input", {
                                    ref_key: "mail_input",
                                    ref: mail_input,
                                    class: "input",
                                    type: "email",
                                    placeholder: "E-Mail",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((mail).value = $event)),
                                    onInput: _cache[2] || (_cache[2] = ($event) => (guest_input()))
                                }, null, 544), [
                                    [_vModelText, mail.value]
                                ]),
                                _createElementVNode("span", _hoisted_9, [
                                    _createVNode(_component_FontAwesomeIcon, { icon: ['fas', 'envelope'] })
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("p", _hoisted_11, [
                                _withDirectives(_createElementVNode("input", {
                                    class: "input is-family-monospace is-uppercase",
                                    type: "text",
                                    placeholder: "Buchungscode",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((booking_code).value = $event)),
                                    onInput: _cache[4] || (_cache[4] = ($event) => (guest_input()))
                                }, null, 544), [
                                    [_vModelText, booking_code.value]
                                ]),
                                _createElementVNode("span", _hoisted_12, [
                                    _createVNode(_component_FontAwesomeIcon, { icon: ['fas', 'hashtag'] })
                                ])
                            ])
                        ]),
                        (ticket_count.value !== null)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass('notification ' + (ticket_count.value > 0 ? 'is-success' : 'is-warning'))
                            }, [
                                _hoisted_13,
                                _createElementVNode("p", null, _toDisplayString(ticket_count.value) + " Reservierungen verfügbar.", 1)
                            ], 2))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("footer", _hoisted_14, [
                        _createVNode(BulmaButton, {
                            class: "is-success",
                            onClick: _withModifiers(submit, ["left"]),
                            icon: ['fas', 'clipboard-check'],
                            text: "Buchen"
                        }),
                        _createVNode(BulmaButton, {
                            class: "is-danger",
                            onClick: _cache[5] || (_cache[5] = _withModifiers(($event) => (_ctx.$emit('close')), ["left"])),
                            icon: ['fas', 'circle-xmark'],
                            text: "Abbrechen"
                        })
                    ])
                ])
            ]));
        };
    }
});
